import { Avatar, Dropdown, Layout, Tooltip, type MenuProps } from "antd";
import Heading from "atoms/heading/heading";
import { getCurrentWorkspace, getUserInfo } from "models/user/selector";
import Stack from "molecules/stack/stack";
import StackItem from "molecules/stackItem/stackItem";
import SettingsDialog from "organisms/settingsDialog/settingsDialog";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getMsalInstance } from "utils/msalInstance";
import { getBaseOldVersionURL } from "utils/helpers";

interface UserBarProps {
  isAuthenticated: boolean;
}

interface UserInfo {
  userName?: string;
  grpId?: string;
  allTenentList?: {
    PartnerID: string;
    UserName: string;
  }[];
}

interface Workspace {
  headerName?: string;
}

export const UserBar: React.FC<UserBarProps> = ({ isAuthenticated }) => {
  const currentWorkspace = useSelector<any, Workspace | undefined>(
    getCurrentWorkspace
  );
  const userInfo = useSelector<any, UserInfo>(getUserInfo);

  const currentTenent = userInfo.allTenentList?.find(
    (t) => t.PartnerID === userInfo.grpId
  );

  useEffect(() => {
    const onFocus = () => {};
    window.addEventListener("focus", onFocus);
    return () => {
      window.removeEventListener("focus", onFocus);
    };
  }, []);

  const logOutSession = (refresh = false) => {
    const msalInstance = getMsalInstance();
    msalInstance.logoutPopup({
      postLogoutRedirectUri: "/",
      mainWindowRedirectUri: "/", // redirects the top level app after logout
    });
    localStorage.clear();
  };

  const items: MenuProps["items"] = [
    {
      key: "logout",
      label: (
        <a onClick={() => logOutSession()}>
          Logout
        </a>
      ),
    },
  ];

  return (
    <div className="header-block">
      <Stack gutter="medium">
        <StackItem isGrow isStretch className="header-lt">
          <Heading type="secondary">
            {currentWorkspace?.headerName ?? "Home"}
          </Heading>
        </StackItem>
        {isAuthenticated && userInfo?.userName && (
          <>
            {/* <StackItem position="center">
              <Tooltip title="Go to older version">
                <a
                  href={getBaseOldVersionURL()}
                  rel="noopener noreferrer"
                  className="header-history"
                >
                  <i className="icon-history" />
                </a>
              </Tooltip>
            </StackItem> */}
            <StackItem position="center">
              <SettingsDialog />
            </StackItem>
            <StackItem>
              <Dropdown menu={{ items }} trigger={["click"]}>
                <Layout style={{ background: "transparent" }}>
                  <Stack
                    gutter="medium"
                    position="center"
                    className="avtar-wrapper"
                  >
                    <StackItem className="avtar-block">
                      <Avatar>{userInfo?.userName?.[0]}</Avatar>
                    </StackItem>

                    <StackItem>
                      <Stack isVertical align="center">
                        <StackItem>{userInfo?.userName}</StackItem>
                        <StackItem className="fw-bold">
                          {currentTenent?.UserName}
                        </StackItem>
                      </Stack>
                    </StackItem>
                  </Stack>
                </Layout>
              </Dropdown>
            </StackItem>
          </>
        )}
      </Stack>
    </div>
  );
};

export default UserBar;
